import { render, staticRenderFns } from "./ReservationUpdateForm.vue?vue&type=template&id=2994f1ba&scoped=true"
import script from "./ReservationUpdateForm.vue?vue&type=script&lang=js"
export * from "./ReservationUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./ReservationUpdateForm.vue?vue&type=style&index=0&id=2994f1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994f1ba",
  null
  
)

export default component.exports